import { useServicePointUsers } from '~/modules/servicepoints/hooks'
import { UsersCard as CommonUsersCard } from '~/common/components'

type Props = {
  organisationId: string
}

export const UsersCard = ({ organisationId }: Props) => {
  const { servicePointUsers, isLoading } = useServicePointUsers(organisationId)

  if (isLoading) {
    return null
  }

  return <CommonUsersCard organisationId={organisationId} isLoading={isLoading} users={servicePointUsers} />
}
